'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Map site codes to alt/title text versions of logo
var textVersions = {
    S: 'HelloSign',
    F: 'HelloFax'
};

/**
 * A scalable HelloSign/HelloFax logo that uses SVG. Can be given size/layout styling via CSS.
 * This could be extended later to include props for overriding the color, e.g. all-white/all-black versions.
 */

var Logo = function (_React$Component) {
    _inherits(Logo, _React$Component);

    function Logo() {
        _classCallCheck(this, Logo);

        return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
    }

    _createClass(Logo, [{
        key: 'render',
        value: function render() {
            var text = textVersions[this.props.siteCode];
            var hsSrc = require('./hellosign.svg');
            var hfSrc = require('./hellofax.svg');
            var src = this.props.siteCode === 'S' ? hsSrc : hfSrc;
            var contents = _react2['default'].createElement('img', { src: src, alt: text, title: text });

            if (this.props.isLink) {
                contents = _react2['default'].createElement(
                    'a',
                    { href: this.props.href },
                    contents
                );
            }

            return _react2['default'].createElement(
                'div',
                { className: 'm-logo' },
                contents
            );
        }
    }]);

    return Logo;
}(_react2['default'].Component);

Logo.propTypes = {
    // Site code to determine which product's logo to use
    siteCode: _react2['default'].PropTypes.oneOf(['S', 'F']).isRequired,
    // If set, the <img> will be wrapped in a <a> which links to the homepage by default
    isLink: _react2['default'].PropTypes.bool,
    // Optional override for the href of the <a> tag
    href: _react2['default'].PropTypes.string
};

Logo.defaultProps = {
    isLink: false,
    href: '/'
};
exports['default'] = Logo;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/logo/index.jsx
 ** module id = 763
 ** module chunks = 0
 **/